import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { UiComponent } from '@df/ui/ui.component';
import compact from 'lodash-es/compact';
import { NProductViewLayout, Product } from '../product.decorator';
import { ProductService } from '../product.service';
@Component({
    selector: 'product-view-specification',
    templateUrl: 'product-view-specification.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class ProductViewSpecificationComponent extends UiComponent implements OnChanges {
    /**
     * Selected product
     */
    @Input()
    product?: Product<IProductDataV3>;
    /**
     * List of sections to show
     */
    @Input()
    attributes?: string[];
    constructor(
        private productService: ProductService
    ) {
        super();
    }
    /**
     * List of times
     */
    items?: NProductViewLayout.IAttributeItem[];
    trackByItem(index: number, item: NProductViewLayout.IAttributeItem): string {
        return item.code;
    }
    /**
     * Override parent method to update sections on changes
     */
    override detectChanges(): void {
        if (!this.attributes || !this.product) {
            this.items = [];
        } else {
            const attributes = Array.isArray(this.attributes) ? this.attributes : [this.attributes];
            this.items = compact(
                attributes?.map(code => this.product && this.productService.getAttributeItem(code, this.product)).filter(i => !!i)
            );
        }
        super.detectChanges();
    }
}
